import { makeStyles } from "..";
import { Field, FieldProps } from "@fluentui/react-components";

interface FieldCustomProps {
  rcName?: string;
}

const useStyles = makeStyles({
  root: {
    fontWeight: 600,
  },
});

const FieldCustom = (props: FieldCustomProps & FieldProps) => {
  const styles = useStyles();
  return <Field {...props} className={styles.root} />;
};

export default FieldCustom;
